import { ProductMenuComponent } from './../../components/product-menu/product-menu.component';
import { AddressComponent } from './address/address.component';
// import { OrderTypeComponent } from './order-type/order-type.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { UpdateProductComponent } from '@app/modules/modals/update-product/update-product.component';
import { SharedModule } from '@app/modules/shared/shared.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PipesModule } from '@app/pipes/pipes.module';
import { PersonalizeProductComponent } from '@app/modules/modals/personalize-product/personalize-product.component';
import { MenuModalComponent } from '@app/modules/modals/menu-modal/menu-modal.component';
import { PersonalizeMenuProductComponent } from '@app/modules/modals/personalize-menu-product/personalize-menu-product';
import { MapsService } from '@app/services/maps/maps.service';
import { groupByCategoryPipe } from '@app/pipes/groupByCategory/groupByCategory.pipe';
import { AbsolutePathModule } from '@app/pipes/absolute-path/absolute-path.module';
import { TabsModule } from 'ngx-bootstrap';
import { OptionsSuppModalComponent } from '@app/modules/modals/options-supp-modal/options-supp-modal.component';
import { HelpycurrencyModule } from '@app/pipes/helpycurrency/helpycurrency.module';
import { TicketComponent } from '@app/components/ticket/ticket.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        AccordionModule.forRoot(),
        TooltipModule.forRoot(),
        SharedModule,
        PipesModule,
        AbsolutePathModule,
        TabsModule.forRoot(),
        HelpycurrencyModule
    ],
    declarations: [
        // OrderTypeComponent,
        UpdateProductComponent,
        PersonalizeProductComponent,
        MenuModalComponent,
        PersonalizeMenuProductComponent,
        AddressComponent,
        groupByCategoryPipe,
        ProductMenuComponent,
        OptionsSuppModalComponent,
        TicketComponent
    ],
    exports: [
        // OrderTypeComponent,
        UpdateProductComponent,
        PersonalizeProductComponent,
        ProductMenuComponent,
        OptionsSuppModalComponent,
        TicketComponent
    ],
    entryComponents: [
        // OrderTypeComponent,
        UpdateProductComponent,
        PersonalizeProductComponent,
        MenuModalComponent,
        PersonalizeMenuProductComponent,
        AddressComponent,
        OptionsSuppModalComponent,
        TicketComponent
    ],
    providers: [
        MapsService
    ]
})

export class ModalsModule {

}
